import { Container, SectionTitle, YoutubeGallery } from '@sloyd/ui';
import { Json } from '../../types';
import { Wrapper } from './ContentTutorials.style';

export type ContentTutorialsProps = {
  clips: Json[];
};

export function ContentTutorials(props: ContentTutorialsProps) {
  const { clips } = props;

  return (
    <Wrapper className='ContentTutorials-wrapper' data-testid='ContentTutorials-wrapper'>
      <Container>
        <SectionTitle gradient={{ from: '#ff9966', to: '#ff5e62' }} title='📘 Tutorials'>
          Learn from the best with our collection of <strong>tutorials</strong>.
        </SectionTitle>
        <YoutubeGallery clips={clips} />
      </Container>
    </Wrapper>
  );
}

export default ContentTutorials;
